<template lang="pug">
  div(class="documents-list")
    div(
      v-for="document in documents"
      :key="document.id"
      class="documents-list__item"
    )
      div(class="d-flex align-start")
        div(class="pt-2")
          div(
            class="documents-list__item-dot"
            :class="{ filled: isPassedDocument(document) }"
          )
        div(class="pl-6 text-left")
          div(class="text-14px light dark") {{ document.title }}
          div(
            class="documents-list__item-reason"
            :class="[isErrorDocument(document) ? 'error-text' : 'skipped']"
          ) {{ getDocumentErrorMessage(document) }}
      div(class="document-list__item-icons")
        block-documents-sign-list-icons(
          :type="isStamp ? 'stamp' : 'eds'"
          :document="document"
          :documents-states="documentsStates"
          :statuses="statuses"
        )
        block-documents-sign-list-icons(
          v-if="isEdsAndStampUploaded"
          type="stamp"
          :document="document"
          :documents-states="documentsStates"
          :statuses="statuses"
        )
</template>

<script>
import BlockDocumentsSignListIcons from '~/modules/documents/components/blocks/block-documents-sign-list-icons'

export default {
  name: 'BlockDocumentsSignList',
  components: {
    BlockDocumentsSignListIcons
  },
  props: {
    documents: {
      type: Array,
      default: () => []
    },
    documentsStates: {
      type: Object,
      default: () => ({})
    },
    statuses: {
      type: Object,
      default: () => ({})
    },
    isEdsAndStampUploaded: {
      type: Boolean,
      default: false
    },
    isStamp: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isPassedDocument(document) {
      return this._.get(this.documentsStates[document.id], 'passed')
    },
    isErrorDocument(document) {
      return this._.get(this.documentsStates[document.id], 'status') === this.statuses.error
    },
    getDocumentErrorMessage(document) {
      return this._.get(this.documentsStates[document.id], 'error.message')
    }
  }
}
</script>

<style scoped lang="scss">
.documents-list {
  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 8px 0;

    &:not(:last-child) {
      margin-bottom: 4px;
    }

    &-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #f0f1f2;

      &.filled {
        background: #000000;
      }
    }

    &-reason {
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      padding-right: 8px;

      &.signing {
        color: $primary;
      }
      &.skipped {
        color: #d2ae22;
      }
      &.error-text {
        color: $danger;
      }
    }

    &-icons {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 4px;
    }
  }
}
</style>
